type Inspection = Readonly<{ siteId: string; findings: number | null; actions: number | null }>;

/** Aggregate the event's site results only; unknown results must never become zero. */
export function headquartersEmphasisInspectionSummary(inspections: readonly Inspection[]) {
  const total = (key: 'findings' | 'actions') => inspections.length && inspections.every(row => row[key] !== null)
    ? inspections.reduce((sum, row) => sum + row[key]!, 0) : null;
  return { findings: total('findings'), actions: total('actions') };
}
